// Module
var code = `<div class="row">
    <div class="col-lg-12 col-md-12 col-xs-12">
        <bfg-chart name="life_time.DauToLTV"></bfg-chart>
    </div>
</div>
`;
// Exports
module.exports = code;